import { render, staticRenderFns } from "./AnimalType.vue?vue&type=template&id=07356002&scoped=true"
import script from "./AnimalType.vue?vue&type=script&lang=js"
export * from "./AnimalType.vue?vue&type=script&lang=js"
import style0 from "./AnimalType.vue?vue&type=style&index=0&id=07356002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07356002",
  null
  
)

export default component.exports